/*
 * Copyright (c) Volvo Group. All rights reserved.
 * SPDX-License-Identifier: ISC
 */

import {
  type EventMessage,
  EventType,
  PublicClientApplication,
  type RedirectRequest,
  type SilentRequest,
} from "@azure/msal-browser";

let isInitialized = false;

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: import.meta.env.VITE_clientId,
    authority: import.meta.env.VITE_URL,
    redirectUri: import.meta.env.VITE_host,
    postLogoutRedirectUri: import.meta.env.VITE_host,
  },
  cache: {
    cacheLocation: "localStorage",
  },
});

export const initializationCallback = () => {
  if (
    !msalInstance.getActiveAccount() &&
    msalInstance.getAllAccounts().length > 0
  ) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0] ?? null);
  }

  // Optional - This will update account state if a user signs in from another tab or window
  msalInstance.enableAccountStorageEvents();

  msalInstance.addEventCallback((event: EventMessage) => {
    const account = (event.payload as SilentRequest)?.account;
    if (event.eventType === EventType.LOGIN_SUCCESS && account) {
      msalInstance.setActiveAccount(account);
    }
  });

  isInitialized = true;
};

export async function getMsalInstance() {
  if (!isInitialized) {
    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise();
    initializationCallback();
    return msalInstance;
  }

  return msalInstance;
}

export const authScopes: RedirectRequest = {
  scopes: (import.meta.env.VITE_scopes as string | undefined)?.split(",") ?? [],
};
